module.exports = __webpack_public_path__ + "img/resolver.759d655f.png";